// extracted by mini-css-extract-plugin
module.exports = {"ConfirmDelete":"ConfirmDelete_ConfirmDelete__rs5HM","Confirm":"ConfirmDelete_Confirm__3IOd7","Cancel":"ConfirmDelete_Cancel__2Kt-Q"};